module.exports = __webpack_public_path__ + "img/xwallet.4bac2345.svg";